import { ErrorHandler, Injectable, isDevMode } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environmnent } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TelemetryService implements ErrorHandler {
  private appInsights?: ApplicationInsights;

  constructor() {
    const connStr = environmnent.appInsightsConnectionString?.trim();
    const isValidKey = Boolean(connStr && !connStr.includes('00000000-0000-0000-0000-000000000000'));

    if (isValidKey) {
      try {
        this.appInsights = new ApplicationInsights({
          config: {
            connectionString: connStr,
            enableAutoRouteTracking: true,
            enableCorsCorrelation: true,
            enableRequestHeaderTracking: true,
            enableResponseHeaderTracking: true,
            disableFlushOnBeforeUnload: true,
            disableFlushOnUnload: true,
            isBeaconApiDisabled: false,
            correlationHeaderExcludedDomains: ['*.core.windows.net']
          }
        });
        this.appInsights.loadAppInsights();
      } catch (err) {
        if (isDevMode()) {
          console.warn('Failed to initialize ApplicationInsights:', err);
        }
      }
    }
  }

  handleError(error: unknown): void {
    if (this.appInsights) {
      try {
        const exception = error instanceof Error
          ? error
          : new Error(typeof error === 'object' && error !== null ? JSON.stringify(error) : String(error || 'Unknown Error'));
        this.appInsights.trackException({ exception });
      } catch {
        // Prevent recursive error handling crashes
      }
    }

    if (isDevMode()) {
      console.error('Unhandled Application Error:', error);
    }
  }
}
